
export async function runWithConcurrency<T, R>(
	items: T[],
	limit: number,
	worker: (item: T, index: number) => Promise<R>,
	onItemSettled?: (result: R, item: T, index: number) => void,
): Promise<R[]> {
	const results: R[] = new Array(items.length);
	let nextIndex = 0;
	let firstError: unknown;
	let hasError = false;

	async function runOne(): Promise<void> {
		while (!hasError) {
			const index = nextIndex++;
			if (index >= items.length) return;

			const item = items[index];
			try {
				const result = await worker(item, index);
				results[index] = result;
				onItemSettled?.(result, item, index);
			} catch (err) {
				if (!hasError) {
					hasError = true;
					firstError = err;
				}
				return;
			}
		}
	}

	const poolSize = Math.max(1, Math.min(limit, items.length));
	await Promise.all(Array.from({ length: poolSize }, () => runOne()));

	if (hasError) throw firstError;
	return results;
}
